<footer id="mainFooter" [hidden]="hideFooter">
  <ng-container *ngTemplateOutlet="templateRef"></ng-container>
</footer>
